export default __webpack_public_path__ + "static/media/like.842ea078.png";